/** Origins that receive the Sirius bearer token. */
export function backendSecureRoutes(apps: Record<string, { url: string }>, doorUrl = ''): string[] {
  const origins = Object.values(apps).map(app => new URL(app.url).origin);
  if (doorUrl) {
    origins.push(new URL(doorUrl).origin);
  }
  return [...new Set(origins)];
}
